import React, { useCallback } from "react";
import { useHistory } from "react-router";
import {
  ContactInformation,
  ContactSelectors,
  useCheckoutStateSelector as useSelector,
  useCheckoutSend,
  ContactEventType,
  type IContactInfo,
} from "@hopper-b2b/checkout";
import { useI18nContext } from "@hopper-b2b/i18n";

import type { TEvent } from "../events";
import { getClientAssets, getStateValue } from "../selectors";
import { uberEmailRegex } from "../utilities";
import { ConnectedBreadcrumbs } from "./Breadcrumbs";
import { ConnectedPriceBreakdownContent } from "./PriceBreakdownDropdown";

export const ConnectedContactInformation = (props) => {
  const { t } = useI18nContext();
  const history = useHistory();
  const send = useCheckoutSend<TEvent>();

  const step = useSelector(getStateValue);
  const clientAssets = useSelector(getClientAssets);

  const contactInfo = useSelector(ContactSelectors.getContactInformation);

  const handleContinue = () => send(ContactEventType.NEXT);

  const handleGoBack = () => {
    history.goBack();
  };

  const onContactInfoChange = useCallback(
    (newContactInfo: IContactInfo) =>
      send({ type: ContactEventType.CHANGE, contactInfo: newContactInfo }),
    [send]
  );

  return (
    <ContactInformation
      {...props}
      contactInfo={contactInfo}
      onGoBack={handleGoBack}
      onContinueClick={handleContinue}
      onContactInfoChange={onContactInfoChange}
      className="b2b"
      fullScreenWithBanner={true}
      desktopRightContent={<ConnectedPriceBreakdownContent />}
      desktopTopContent={<ConnectedBreadcrumbs />}
      clientAssets={clientAssets}
      step={step}
      headerTitle={t("contactInformation")}
      emailRegex={uberEmailRegex}
    />
  );
};
